import Logo from "assets/images/imageIcons/logo.png";
import LogoWhite from "assets/images/imageIcons/logo_white.svg";
import LogoMin from "./imageIcons/mini-logo.png";
import ArrowRight from "./imageIcons/arrow-right.png";
import hamburger from "./imageIcons/hamburger.png";
import bell from "./imageIcons/bell.png";
import admin from "./imageIcons/admin.png";
import Filter from "./imageIcons/filter-icon.png";
import AddUser from "./imageIcons/add-user.png";
import FilterW from "./imageIcons/filter-icon-w.png";
import arrowDown from "./imageIcons/arrow-down.png";
import tick from "./imageIcons/tick.png";
import alert from "./imageIcons/alert.png";
import parkplusLogo from "./imageIcons/favicon.webp";
import arrowRightBlue from "./imageIcons/arrow-right-blue.png";
import infoIcon from "./imageIcons/info.png";
import fileIcon from "./imageIcons/file-icon.png";
import viewIcon from "./imageIcons/view-icon.png";
import BackArrowBlack from "./imageIcons/back-arrow.png";
import LoaderGif from "./imageIcons/loader.gif";
import FolderIcon from "./imageIcons/folder.png";
import ImageIcon from "./imageIcons/image.png";
import PdfIcon from "./imageIcons/pdf.png";
import VideoIcon from "./imageIcons/video.png";
import CartIcon from "./imageIcons/cart.png";
import SelectMenu from "./imageIcons/select.png";
import DocIcon from "./imageIcons/doc_icon.png";
import NoData from "./imageIcons/noData.png";
import DeleteIcon from "./imageIcons/delete.png";
import GoogleLogo from "./imageIcons/google-logo.png";
import ERRORIMG from "./imageIcons/error.gif";
import AssesmentVideoIcon from "./imageIcons/assesment-video-icon.png";
import AssesmentFileIcon from "./imageIcons/assesment-file.png";
import Visit from "./imageIcons/visit.png";
import Incentive from "./imageIcons/incentive.png";
import Location from "./imageIcons/location.png";
import Calendar from "./imageIcons/calendar.png";
import Building from "./imageIcons/building.png";
import OffroleEmployee from "./imageIcons/offrole_employees.png";
import ConfirmationIcon from "./imageIcons/confirmation.png";

const Images = {
  Logo: Logo,
  Calendar:Calendar,
  Location:Location,
  Building:Building,
  LogoWhite : LogoWhite,
  LogoMin: LogoMin,
  ArrowRight: ArrowRight,
  hamburger: hamburger,
  bell: bell,
  admin: admin,
  Filter: Filter,
  FilterW:FilterW,
  AddUser:AddUser,
  arrowDown: arrowDown,
  tick: tick,
  alert:alert,
  DocIcon:DocIcon,
  parkplusLogo:parkplusLogo,
  arrowRightBlue: arrowRightBlue,
  infoIcon: infoIcon,
  fileIcon: fileIcon,
  viewIcon: viewIcon,
  BackArrowBlack: BackArrowBlack,
  LoaderGif: LoaderGif,
  FolderIcon: FolderIcon,
  ImageIcon: ImageIcon,
  PdfIcon: PdfIcon,
  VideoIcon: VideoIcon,
  CartIcon: CartIcon,
  SelectMenu:SelectMenu,
  NoData : NoData,
  DeleteIcon : DeleteIcon,
  GoogleIcon : GoogleLogo,
  ErrorImg:ERRORIMG,
  AssesmentVideoIcon : AssesmentVideoIcon,
  AssesmentFileIcon : AssesmentFileIcon,
  Visit:Visit,
  Incentive:Incentive,
  OffroleEmployee: OffroleEmployee,
  ConfirmationIcon: ConfirmationIcon
};

export { Images };
export default Images;
